import { render } from "./security.vue?vue&type=template&id=49d04801&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=49d04801&scoped=true&lang=css&external"
import "./security.vue?vue&type=style&index=1&id=49d04801&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d04801"]])

export default __exports__